<template lang="pug">
div
  b-navbar(toggleable='md' type='dark' variant='primary' /*fixed="top"*/)
    b-container
      b-navbar-brand(:to="{name: 'Home'}")
        img.navbar-brand(src="../assets/logo_flight_center_white.svg")
      b-navbar-toggle(target='nav-collapse')
      b-collapse#nav-collapse(is-nav='')
        b-navbar-nav.ml-auto
          b-nav-item(:to="{name: 'Home'}" v-if="role == 'admin' || role == 'counter' && this.$cookies.get('token')" exact) Inicio
          b-nav-item(:to="{name: 'Login'}" v-if="!this.$cookies.get('token')" exact) Login
          b-nav-item( :to="{name: 'Search'}" v-if="role == 'admin' || role == 'accountant'") Búsqueda
          b-nav-item( :to="{name: 'Clients'}" v-if="role == 'admin' || role == 'accountant'") Clientes
          b-nav-item( :to="{name: 'Promotions'}" v-if="role == 'admin' || role == 'counter'") Promociones
          b-nav-item( :to="{name: 'Notifications'}" v-if="role == 'admin' || role == 'counter'") Notificaciones
          //b-nav-form
            b-form-input.mr-sm-2(size='sm' placeholder='Search')
            b-button.my-2.my-sm-0(size='sm' type='submit') Search
          //b-nav-item-dropdown(text='Lang' right='')
            b-dropdown-item(href='#') EN
            b-dropdown-item(href='#') ES
            b-dropdown-item(href='#') RU
            b-dropdown-item(href='#') FA
          b-nav-item-dropdown(right='' v-if="this.$cookies.get('token')")
            // Using 'button-content' slot
            template(v-slot:button-content='')
              //em User
              span Usuario
            //b-dropdown-item(href='#') Profile
            b-dropdown-item(href='#' @click="logout" prevent) Cerrar sesión
  //- nav
  //-   .container
  //-     .row
  //-       .col-3
  //-         img.navbar-brand(src="./assets/fc-logo@2x.png")
  //-       ul.col-9
  //-         li
  //-           router-link(to="/") Inicio
  //-         li
  //-           router-link(to="/search") Buscador de operaciones
  //-         li
  //-           router-link(to="/logout") Cerrar sesión
</template>

<script>
//import axios from "axios";

//import { mapState, mapGetters } from "vuex";

export default {
  name: "PxHeader",
  props: {
    title: String,
  },
  data() {
    return {
      role: "counter",
    };
  },
  mounted() {
    // TODO: usar store?
    this.role = this.$cookies.get("role");
  },
  /*computed: {
    ...mapState(["operations", "loading", "errored"]),
    ...mapGetters(["operations", "loading", "errored"]),
  },*/
  /*mounted() {

  },*/
  methods: {
    /*getOperations() {
      this.$store.commit("getOperations", this.operations);
      console.log(this.$store.state.operations);
    },*/
    logout() {
      this.$cookies.remove("token");
      this.$cookies.remove("id");
      this.$cookies.remove("userName");
      this.userName = "";
      this.$router.go("/");
    },
  },
};
</script>

<style>
nav {
  background-color: var(--azul);
}

.navbar-brand {
  max-width: 145px;
  width: 100%;
  height: auto;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="stylus">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

@media (min-width: 576px) {
  .card-columns {
    column-count: 2;
  }
}
</style>
-->
